import {
  CreateItemTypeCacheKeys,
  ItemTypePrice,
  ItemTypeID,
  ItemTypeViewPrice,
  ItemTypeViewPriceCurrency,
  ItemTypeName
} from '../../itemTypesTypes';
import { CompanyID, CompanyNanoID } from '../../../companies/companiesTypes';
import { ItemTagPosition, ItemTagID } from '../../../itemTags/itemTagsTypes';
import { CreateItemGqlError, CreateItemGqlStatus } from '../../../../types';
import { ItemCategoryID } from '../../../itemCategories/itemCategoriesTypes';

import { CACHE_CREATE_ITEM_TYPE_QUERY } from '../../queries/cacheCreateItemType.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CacheCreateItemTypeOptions {
  cacheKeys?: CreateItemTypeCacheKeys;
}

export interface CreateItemTypeInput {
  companyId?: CompanyID;
  companyNanoId?: CompanyNanoID;
  itemCategoryId: ItemCategoryID;
  itemTypeItemTagsAttributes?: {
    position: ItemTagPosition;
    itemTagId: ItemTagID;
  }[];
  name?: ItemTypeName;
  price: ItemTypePrice;
  viewPrice?: ItemTypeViewPrice;
  viewPriceCurrency?: ItemTypeViewPriceCurrency;
}

interface CacheCreateItemTypeError {
  fullMessages: string[];
}

interface CacheCreateItemTypeItemType {
  id: ItemTypeID;
  name: ItemTypeName;
  price: ItemTypePrice;
  viewPrice: ItemTypeViewPrice;
  viewPriceCurrency: ItemTypeViewPriceCurrency;
}

interface CacheCreateItemTypeResponseType<CreateItemTypeItemType> {
  createItemType: {
    status: CreateItemGqlStatus;
    record: CreateItemTypeItemType;
    errors: CreateItemGqlError;
    recordId: ItemTypeID;
  };
}

const action = 'createItemType';

function useCacheCreateItemType({
  cacheKeys
}: CacheCreateItemTypeOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryData,
    createCacheQueryError,
    createCacheQueryErrorMessage,
    createCacheQueryLoading,
    createCacheQueryReset
  } = useCacheCreateQuery<
    CreateItemTypeInput,
    CacheCreateItemTypeResponseType<CacheCreateItemTypeItemType>,
    CacheCreateItemTypeError,
    CacheCreateItemTypeItemType
  >({ action, query: CACHE_CREATE_ITEM_TYPE_QUERY, cacheKeys });

  return {
    createItemType: createCacheQuery,
    createItemTypeData: createCacheQueryData,
    createItemTypeError: createCacheQueryError,
    createItemTypeErrorMessage: createCacheQueryErrorMessage,
    createItemTypeLoading: createCacheQueryLoading,
    createItemTypeReset: createCacheQueryReset
  };
}

export default useCacheCreateItemType;
